import { InitialEventFilterCriteria } from "../events/filter/EventFilterCriteria";
import { type ContentScreenState } from "../screen/configs";
import { ContentTabs, Screen } from "../screen/tabs";

export const InitialContentEventScreen: ContentScreenState = {
  screenId: Screen.CONTENT,
  activeTabId: ContentTabs.EVENTS,
  filters: InitialEventFilterCriteria,
};
